import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BasePage } from 'src/app/core/base-page';
import { ServiceHelper } from 'src/app/core/helper/services.helper';
import { RegisterRequest } from '../../data/schema/auth-models';
import { AuthenticationService } from '../../data/service/authentication.service';
import { Log } from 'src/app/core/log';
import { Utilities } from 'src/app/core/helper/util';

@Component({
  selector: 'app-register-form',
  templateUrl: './register-form.component.html',
  styleUrls: ['./register-form.component.scss'],
})
export class RegisterFormComponent extends BasePage implements OnInit{

  // this is email coming from login screen so user doesn't have to ree-nter
  @Input() email: string;
  
  // Page outputs
  @Output() loginClicked = new EventEmitter();
  @Output() registerComplete = new EventEmitter<RegisterRequest>();
  @Output() forgotClicked = new EventEmitter();
  

  model: RegisterRequest = new RegisterRequest();

  showPwd: boolean = false;

  constructor(
    authService: AuthenticationService) {
    super(authService);
  }

  ngOnInit() {
    if ( this.email != null ) {
      this.model.username = this.email;
    }
  }

  login() {
    this.loginClicked.emit();
  }

  goToForgot() {
    this.forgotClicked.emit();
  }

  async register() {
    if (navigator.onLine === false) {
      ServiceHelper.displayAlert('No Internet Connection!', 'You are not connected to the internet. Can\'t register!');
    } else if (this.model.password == null || this.model.password.length < 8) {
      ServiceHelper.displayAlert('Invalid Password!', 'Password must be at least 8 characters long.');
    } else if (Utilities.stringEmpty(this.model.firstName)) {
      ServiceHelper.displayAlert('Invalid First Name!', 'First name is required.');
    } else if (Utilities.stringEmpty(this.model.lastName)) {
      ServiceHelper.displayAlert('Invalid Last Name!', 'Last name is required.');
    } else {
      // default displayname to first name
      this.model.displayName = this.model.firstName;
      try {
        this.pageState.busy = true;
        await this.authService?.register(this.model);
        this.pageState.busy = false;
        this.registerComplete.emit(this.model);
      } catch (error: any) {
        console.error('Error registering', error);
        ServiceHelper.displayAlert('Registration Error', error);
        this.pageState.busy = false;
      }
    }
  }
}
